import * as React from 'react';
export const paycoSvg = React.forwardRef(function paycoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.051 6.723c0 .745-.56 1.318-1.52 1.318H7.014V5.377h1.482c.958 0 1.556.462 1.556 1.321v.025Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M1.25 0h13.5C15.44 0 16 .56 16 1.25v13.5c0 .69-.56 1.25-1.25 1.25H1.25C.56 16 0 15.44 0 14.75V1.25C0 .56.56 0 1.25 0Zm4.802 3.645a.951.951 0 0 0-.958.958h-.002v6.949a.95.95 0 0 0 .958.958.951.951 0 0 0 .958-.958V9.747h1.458c1.956 0 3.525-1.047 3.525-3.063v-.025c0-1.782-1.257-3.014-3.337-3.014H6.052Z',
      clipRule: 'evenodd',
    }),
  );
});
paycoSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var payco = {
  category: 'paymentmethod',
  colorable: true,
  name: 'payco',
  svg: paycoSvg,
};
